import { render, staticRenderFns } from "./BudgetProject.vue?vue&type=template&id=4bdd1869&scoped=true"
import script from "./BudgetProject.vue?vue&type=script&lang=js"
export * from "./BudgetProject.vue?vue&type=script&lang=js"
import style0 from "./BudgetProject.vue?vue&type=style&index=0&id=4bdd1869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd1869",
  null
  
)

export default component.exports